module.exports = function(app) {
    "use strict";
    app.directive('providerDisclaimer', ["services","$state","modal",
        function(services, $state, modal){

            return {
                restrict: 'A',
                replace: true,
                scope: {
                    referrer: "="
                },
                template: '<p class="margin-top bottom-modules"><button type="button" class="btn-link" data-ng-click="providerDisclaimer()" data-teamsite="BTS_PROVIDER_DETAIL_PROFESSIONAL_PHYSICIAN_DETAILS_DISCLAIMER_LINK_TEXT"></p>',
                link: function(scope) {
                    scope.providerDisclaimer = function () {
                        modal.open({
                            template: '<span data-teamsite="BTS_PROVIDER_DETAIL_PROFESSIONAL_PHYSICIAN_DETAILS_DISCLAIMER_BODY"></span>',
                            scope : scope
                        });
                    };
                }
            };
        }]);
};